import Custom from './Custom';
import { MultiImage } from '../Image.types';
import { getClassNames } from '../../../helpers/classHelpers';
import styles from '../Image.module.scss';

export default function ImageSlider({ className, images }: MultiImage) {
    return <div className={getClassNames([styles.slider, className])}>
        <Custom className={className} images={images} enableThumbs />
    </div>;
};